<div class="container-fluid p-4">
  <!-- Header -->
  <div class="page-header">
    <div>
      <h2><i class="bi bi-bank me-2"></i>Contas Bancárias</h2>
      <p class="text-muted mb-0">Gerencie suas contas bancárias</p>
    </div>
    <button class="btn btn-primary btn-sm" (click)="openModal()">
      <i class="bi bi-plus-circle me-1"></i> Nova Conta Bancária
    </button>
  </div>
  <hr/>

  <!-- Filtros -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-2">
        <div class="col-md-6">
          <input type="text" class="form-control" placeholder="🔍 Buscar por banco, conta..."
                 [value]="filter.search" (input)="onSearch($any($event.target).value)">
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela -->
  <div class="card">
    <div class="card-body">
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border" role="status"></div>
      </div>

      <div *ngIf="!loading && result.items.length === 0" class="text-center py-5 text-muted">
        <i class="bi bi-inbox" style="font-size: 3rem;"></i>
        <p class="mt-2">Nenhuma conta bancária encontrada</p>
      </div>

      <table *ngIf="!loading && result.items.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th>Banco</th>
            <th>Conta</th>
            <th>Tipo</th>
            <th>Saldo Inicial</th>
            <th>Criado em</th>
            <th class="text-end">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let b of result.items">
            <td><strong>{{ b.bankName }}</strong></td>
            <td>{{ b.accountNumber || '-' }}</td>
            <td>{{ b.accountType || '-' }}</td>
            <td>{{ b.initialBalance | currency:'BRL' }}</td>
            <td>{{ fmtDate(b.createdAt) }}</td>
            <td class="text-end">
              <button class="btn btn-sm btn-outline-primary me-1" (click)="openModal(b)" title="Editar">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="delete(b)" title="Excluir">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginação -->
      <div *ngIf="result.totalCount > result.pageSize" class="d-flex justify-content-between align-items-center mt-3">
        <div class="text-muted">
          Exibindo {{ result.items.length }} de {{ result.totalCount }} registros
        </div>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="result.page === 1">
              <a class="page-link" (click)="result.page > 1 && onPageChange(result.page - 1)">Anterior</a>
            </li>
            <li class="page-item" *ngFor="let p of [].constructor(result.totalPages); let i = index"
                [class.active]="i + 1 === result.page">
              <a class="page-link" (click)="onPageChange(i + 1)">{{ i + 1 }}</a>
            </li>
            <li class="page-item" [class.disabled]="result.page === result.totalPages">
              <a class="page-link" (click)="result.page < result.totalPages && onPageChange(result.page + 1)">Próximo</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ editingId ? 'Editar' : 'Nova' }} Conta Bancária</h5>
        <button type="button" class="btn-close" (click)="showModal = false"></button>
      </div>
      <div class="modal-body">
        <div class="row g-3">
          <div class="col-md-12">
            <label class="form-label">Banco <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="form.bankName">
          </div>
          <div class="col-md-6">
            <label class="form-label">Número da Conta</label>
            <input type="text" class="form-control" [(ngModel)]="form.accountNumber">
          </div>
          <div class="col-md-6">
            <label class="form-label">Tipo de Conta</label>
            <input type="text" class="form-control" [(ngModel)]="form.accountType" placeholder="Ex: Corrente, Poupança">
          </div>
          <div class="col-md-12">
            <label class="form-label">Saldo Inicial</label>
            <input type="number" class="form-control" [(ngModel)]="form.initialBalance" step="0.01">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="showModal = false" [disabled]="saving">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>
